<script>

    import { orderLinkStore, popupStore } from '../stores'
    import { toast } from 'bulma-toast'
    import { createEventDispatcher } from 'svelte'

    import StripeService from '../$services/stripe.service'

    import Spinner from '../$components/spinner.svelte'

    const { STRIPE_KEY } = _CONSTANTS_
    const { BRAND } = _CONSTANTS_

    const dispatch = createEventDispatcher()

    export let delivery;
    export let quotation;
    export let orderId;
    export let requestAccess;

    let loading = false

    let data = {}
    let tag = ''
    let documentFormat = 'pdf'

    async function createCheckoutLink() {

        data = {
            national: {
                orderId,
                delivery,
                linkId: $orderLinkStore._id,
                pickup: $orderLinkStore.pickup,
                packageContent: $orderLinkStore.package.content,
                token: quotation.token,
                documentFormat,
                tag
            }
        }

        const queryData = {
            requestAccess
        }

        loading = true
        const resp = await StripeService.createCheckoutLink(data, queryData)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        window.Stripe(STRIPE_KEY).redirectToCheckout({ sessionId: resp.data })

        setTimeout(() => {
            setStep('finish')
        }, 3000)
    }

    function setStep(step) {
        dispatch('step', step)
    }

</script>

<Spinner {loading} />

{#if !loading}
    <form on:submit|preventDefault={createCheckoutLink}>
        <div class="columns">
            <div class="column">
                <div class="title">Origen</div>
                <div><b>{ $orderLinkStore.pickup.contact }</b></div>
                <div>{ $orderLinkStore.pickup.rfc || 'Sin información' }</div>
                <div>{ $orderLinkStore.pickup.corporate || 'Sin información' }</div>
                <div>{ $orderLinkStore.pickup.phone }</div>
                <div>{ $orderLinkStore.pickup.email }</div>
                <div>{ $orderLinkStore.pickup.street }</div>
                <dd>{ $orderLinkStore.pickup.number }, { $orderLinkStore.pickup.apartment || '' }</dd>
                <div>{ $orderLinkStore.pickup.colony }</div>
                <div><b>{ $orderLinkStore.pickup.zipcode }</b> { $orderLinkStore.pickup.municipality || '' }, { $orderLinkStore.pickup.city }, { $orderLinkStore.pickup.state }</div>
                <div>{ $orderLinkStore.pickup.references }</div>
                <small><b>{ $orderLinkStore.pickup.sendEmail? 'Se envía correo de confirmación' : 'No se envía correo de confirmación' }</b></small>
            </div>
            <div class="is-divider-vertical"></div>
            <div class="column">
                <div class="title">Destino</div>
                <div><b>{ delivery.contact }</b></div>
                <div>{ delivery.rfc || 'Sin información' }</div>
                <div>{ delivery.corporate || 'Sin información' }</div>
                <div>{ delivery.phone }</div>
                <div>{ delivery.email }</div>
                <div>{ delivery.street }</div>
                <div>{ delivery.number }, { delivery.apartment || '' }</div>
                <div>{ delivery.colony }</div>
                <div><b>{ delivery.zipcode }</b> { delivery.municipality || '' }, { delivery.city }, { delivery.state }</div>
                <div>{ delivery.references }</div>
                <small><b>{ delivery.sendEmail? 'Se envía correo de confirmación' : 'No se envía correo de confirmación' }</b></small>
                <div class="items-end">
                    <button on:click={() => setStep('delivery')} class="button">
                        <span class="icon"><i class="fas fa-edit"></i></span>
                        <span>Editar</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="is-divider"></div>
        <div class="columns">
            <div class="column">
                <div class="title">Paquete</div>
                <div class="items-space">
                    <div>
                        <div>{quotation.package.width}cm x {quotation.package.height}cm x {quotation.package.length}cm | {quotation.package.weight}Kg</div>
                        {#if quotation.package.value}
                            <div>Valor declarado ${quotation.package.value}</div>
                        {/if}
                    </div>
                    <div><b>{quotation.package.volumetric}Kg Volumétrico</b></div>
                </div>
                <div>{ $orderLinkStore.package.content }</div>
            </div>
        </div>
        <div class="is-divider"></div>
        <div class="columns">
            <div class="column">
                <div class="items-center col">
                    <img class="provider-image" src="images/{quotation.provider.replace(' Partner', '')}.svg" alt="{quotation.provider}">
                    <div class="title">{quotation.service}</div>
                    <div class="subtitle"><b>${quotation.finalPrice}</b></div>
                    <div class="items-end">
                        <button on:click={() => setStep('quotation')} class="button">
                            <span class="icon"><i class="fas fa-edit"></i></span>
                            <span>Editar</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="is-divider-vertical"></div>
            <div class="column">
                {#if (quotation.paymentType === 'wallet' || quotation.paymentType === 'account')}
                    <div class="items-space">
                        <div>Envío</div>
                        <div>${quotation.shipmentPrice}</div>
                    </div>
                {:else if quotation.paymentType === 'prepaid'}
                    <div class="items-space">
                        <div>Envío</div>
                        <div>$0</div>
                    </div>
                {/if}
                {#if quotation.insurancePrice}
                    <div class="items-space">
                        <div>Seguro</div>
                        <div>${quotation.insurancePrice}</div>
                    </div>
                {/if}
                {#if quotation.aggregatePrice}
                    <div class="items-space">
                        <div>Extra</div>
                        <div>${quotation.aggregatePrice}</div>
                    </div>
                {/if}
                <br>
                <div class="tags items-center">
                    <span class="tag">{quotation.days} Días aproximado</span>
                    {#if !quotation.isDeliveryHome}
                        <span class="tag is-danger">Sin entrega a domicilio</span>
                    {/if}
                    {#if quotation.isCoverageCost}
                        <span class="tag is-danger">Zona extendida</span>
                    {/if}
                    {#if quotation.paymentType === 'prepaid'}
                        <span class="tag is-primary">Guía prepago {quotation.prepaidShipments}/{quotation.prepaidShipmentsTotal}</span>
                    {/if}
                </div>
                <div>
                    {#if quotation.information}
                        <span class="tag is-primary icon-text" style="color: white;">
                            <span>{quotation.information}&nbsp;&nbsp;</span>
                            <span on:click={() => popupStore.set('frequency_popup')} class="class-icon"><i class="fas fa-question-circle" style="color: whitesmoke; cursor: pointer;"></i></span>
                        </span>
                    {/if}
                </div>
            </div>
        </div>
        <div class="items-end">
            <button type="submit" class="button is-primary">
                <span class="icon"><i class="fas fa-truck"></i></span>
                <span>Generar guía</span>
            </button>
        </div>     
    </form>
{/if}
